export default __webpack_public_path__ + "static/media/bookmark.0ce9c451.svg";